<template>
    <v-card>
        <v-toolbar dark color="primary" flat>
            <v-btn 
                icon 
                dark 
                :disabled="saving" 
                @click="close">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="sessionID">Add Break/Move</span>
                <span v-else>Edit Break/Move</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout row align-center justify-center fill-height v-if="loading">
            <v-flex shrink>
                <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
        </v-layout>
        <v-form v-else ref="editForm" v-model="editValid">
            <v-container>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-flex xs12>
                            <v-select label="Break / Move" v-model="editedItem.Break.BreakTypeID" @input="breakTypeChanged" :items="breakTypes" item-text="Name" item-value="BreakTypeID" :rules="[rules.selectRequired]"></v-select>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-menu
                            ref="menu1"
                            v-model="startTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="startTime"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="startTime"
                                    label="Start Time"
                                    prepend-icon="access_time"
                                    readonly
                                    :error="!validTimes"
                                    :error-messages="errorMsgs"
                                    :rules="[rules.required]"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="startTimeMenu"
                                v-model="startTime"
                                full-width
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="startTimeMenu = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.menu1.save(startTime)">OK</v-btn>
                            </v-time-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-menu
                            ref="menu2"
                            v-model="endTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="endTime"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="endTime"
                                    label="End Time"
                                    prepend-icon="access_time"
                                    :error="!validTimes"
                                    :error-messages="errorMsgs"
                                    readonly
                                    :rules="[rules.required]"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="endTimeMenu"
                                v-model="endTime"
                                full-width
                            >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="endTimeMenu = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.menu2.save(endTime)">OK</v-btn>
                            </v-time-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 v-if="sessionID > 0">
                        <v-checkbox
                            :value="editedItem.SplitSession"
                            @change="splitSessionChanged"
                            label="Split Session"
                        >
                        </v-checkbox>
                    </v-flex>
                    <v-flex xs12 pb-5 v-for="(item, index) in timeLines" :key="index">
                        <span >{{ item.label }}</span>
                        <vue-slider :ref="'vueSlider'+index" :value="item.time" :data="timeIntervals" :marks="true" :clickable="false" :useKeyboard="false" :railStyle="{ background:'#ccc' }" :dotStyle="{ background: item.color }" :processStyle="{ background: item.color }" :stepStyle="{ background: item.color }" :stepActiveStyle="{ background: item.color }" :tooltipStyle="{ background: item.color }" ></vue-slider>
                    </v-flex>             
                    <v-flex xs12 sm6>
                        <v-btn 
                            block 
                            color="success" 
                            :disabled="!editValid && error == null" 
                            :loading="saving" 
                            @click="save">
                            <span>Save</span>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-btn 
                            block 
                            color="error" 
                            :disabled="saving" 
                            @click="close">
                            <span>Cancel</span>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <v-alert 
                            :value="error" 
                            outline 
                            type="error">
                            <span>{{ error }}</span>
                        </v-alert>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </v-card>    
</template>

<script>
import attendanceApi from "@/api/attendanceApi";
import cropWorkAttendanceApi from "@/api/cropWorkAttendanceApi";
import validationRules from "@/helpers/validationrules";
import BaseAPI from "@/api/baseApi";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { nextTick } from "@vue/runtime-dom";

export default {
    components: {
        VueSlider
    },
    data() {
        return {
            rules: validationRules.rules,
            loading: false,
            attendance: null,
            startTimeMenu: false,
            endTimeMenu: false,
            editedItem: {
                AttendanceID: null,
                SplitSession: false,
                ModifiedSessions: [],
                ModifiedBreaks: [],
                Break: {
                    BreakID: -1,
                    BreakTypeID: null,
                    StartTime: null,
                    EndTime: null,
                },
            },
            breakTypes: [],           
            saving: false,
            error: null,
            editValid: false
        }
    },
    computed: {
        sessionID() {
            return parseInt(this.$route.query.sessionID);
        },
        breakID() {
            return parseInt(this.$route.query.breakID);
        },
        attendanceID() {
            return parseInt(this.$route.query.attendanceID);
        },
        isCropWork() {
            return this.$route.query.isCropWork != null;
        },
        startTime: {
            get() {
                if(this.editedItem.Break.StartTime == undefined || this.editedItem.Break.StartTime == null){
                    return '00:00'
                }

                return this.editedItem.Break.StartTime
            },
            set(v) {
                this.startTimeChanged(v)
            }
        },
        endTime: {
            get() {
                if(this.editedItem.Break.EndTime == undefined || this.editedItem.Break.EndTime == null){
                    return '00:00'
                }

                return this.editedItem.Break.EndTime;
            },
            set(v) {
                this.endTimeChanged(v)
            }
        },
        validTimes() {
            if(this.editedItem.Break.StartTime && this.editedItem.Break.EndTime) {
                let start = new Date('1970-01-01T' + this.editedItem.Break.StartTime);
                let end = new Date('1970-01-01T' + this.editedItem.Break.EndTime);
                return start < end;
            }

            return true;
        },
        errorMsgs() {
            if(this.validTimes){
                return [];
            }
            return [ "Start time must be before End time" ]
        },
        timeLines() {
            let timeLine = [];

            if (this.attendance) {
                // If we are adding a break to a session
                if (this.sessionID && this.sessionID > 0) {
                    let modifiedSession = this.editedItem.ModifiedSessions.find(s => s.SessionID == this.sessionID);

                    // If we haven't edited this session?
                    if (!modifiedSession) {
                        // Find the session in the attendance data and add it
                        let session = this.attendance.Sessions.find(s => s.SessionID == this.sessionID);

                        timeLine.push({
                            label: session.SessionName,
                            time: [session.StartTime, session.EndTime],
                            color: '#3498db'
                        });
                    }
                }

                // If we are modifying a break
                if (this.breakID) {
                    // Find the break in the attendance
                    let foundBreak = null;

                    this.attendance.Sessions.forEach(session => {
                        foundBreak = session.Breaks.find(b => b.BreakID == this.breakID);

                        if (foundBreak) {
                            // Add Session data if it hasn't already been modfied
                            let modifiedSession = this.editedItem.ModifiedSessions.find(s => s.SessionID == session.SessionID);

                            if (!modifiedSession) {
                                timeLine.push({
                                    label: session.SessionName,
                                    time: [session.StartTime, session.EndTime],
                                    color: '#3498db'
                                });
                            }

                            // Add all the breaks
                            session.Breaks.forEach(breakModel => {
                                let modifiedBreak = this.editedItem.ModifiedBreaks.find(b => b.BreakID == breakModel.BreakID);

                                // If we haven't modifed this break and it isn't the break we are currently editing then add it to the list
                                if (!modifiedBreak && breakModel.BreakID != foundBreak.BreakID) {
                                    timeLine.push({
                                        label: breakModel.BreakName,
                                        time: [breakModel.StartTime, breakModel.EndTime],
                                        color: breakModel.Color
                                    });
                                }
                            });
                        }
                    });
                }

                // Add all modified entities
                this.editedItem.ModifiedSessions.forEach(session => {
                    timeLine.push({
                        label: session.SessionName,
                        time: [session.StartTime, session.EndTime],
                        color: '#3498db'
                    });
                });

                this.editedItem.ModifiedBreaks.forEach(breakModel => {
                    timeLine.push({
                        label: breakModel.BreakName,
                        time: [breakModel.StartTime, breakModel.EndTime],
                        color: breakModel.Color
                    });
                });

                // Add break we are editing
                if (this.editedItem.Break) {
                    if (this.editedItem.Break.StartTime && this.editedItem.Break.EndTime && this.editedItem.Break.BreakTypeID) {
                        let type = this.breakTypes.find(bt => bt.BreakTypeID == this.editedItem.Break.BreakTypeID);

                        timeLine.push({
                            label: type.Name + (this.breakID > 0 ? " (EDIT)" : " (NEW)"),
                            time: [this.editedItem.Break.StartTime, this.editedItem.Break.EndTime],
                            color: type.Color
                        });
                    }
                }
            }

            let sorted = timeLine.sort((a, b) => {
                let dateA = new Date('1970-01-01T' + a.time[0] + ':00Z');
                let dateB = new Date('1970-01-01T' + b.time[0] + ':00Z');

                if (dateA > dateB) return 1;               
                if (dateA < dateB) return -1;

                return 0;
            });

            return sorted;
        },
        timeIntervals() {
            let intervals = [];

            this.timeLines.forEach(timeLine => {
                if (!intervals.includes(timeLine.time[0])) intervals.push(timeLine.time[0]);
                if (!intervals.includes(timeLine.time[1])) intervals.push(timeLine.time[1]);
            });

            let sorted = intervals.sort((a, b) => {
                let dateA = new Date('1970-01-01T' + a + ':00Z');
                let dateB = new Date('1970-01-01T' + b + ':00Z');

                if (dateA > dateB) return 1;               
                if (dateA < dateB) return -1;

                return 0;
            });

            return sorted;
        }
    },    
    methods: {
        breakTypeChanged() {
            this.startTimeChanged(this.editedItem.Break.StartTime);
        },
        startTimeChanged(val) {
            this.editedItem.Break.StartTime = val;

            let type = this.breakTypes.find(x => x.BreakTypeID == this.editedItem.Break.BreakTypeID);
            if (val && (type.Name == "Paid Break" || type.Name == "Unpaid Break")) {
                let minutesToShift = type.Name == "Paid Break" ? 15 : 30;
                this.editedItem.Break.EndTime = this.getShiftedTimeByMinutes(val, minutesToShift);
            }
            
            this.recalculateTimes();
        },
        endTimeChanged(val) {
            this.editedItem.Break.EndTime = val;

            let type = this.breakTypes.find(x => x.BreakTypeID == this.editedItem.Break.BreakTypeID);
            if (val && (type.Name == "Paid Break" || type.Name == "Unpaid Break")) {
                let minutesToShift = type.Name == "Paid Break" ? -15 : -30;
                this.editedItem.Break.StartTime = this.getShiftedTimeByMinutes(val, minutesToShift);
            }

            this.recalculateTimes();
        },
        getShiftedTimeByMinutes(baseTime, minutesToShift) {
            const timeParts = baseTime.split(':');

            const date = new Date();
            date.setHours(parseInt(timeParts[0], 10));
            date.setMinutes(parseInt(timeParts[1], 10) + minutesToShift);
            date.setSeconds(0);

            const shiftedHours = date.getHours().toString().padStart(2, '0');
            const shiftedMinutes = date.getMinutes().toString().padStart(2, '0');

            return `${shiftedHours}:${shiftedMinutes}`;
        },
        splitSessionChanged(val) {
            this.editedItem.SplitSession = val;
            this.recalculateTimes();
        },
        recalculateTimes() {
            this.error = null;
            this.editedItem.ModifiedSessions = [];
            this.editedItem.ModifiedBreaks = [];

            // Only recalculate times once they are captured
            if (this.editedItem.Break.StartTime && this.editedItem.Break.EndTime) {
                let breakStart = new Date('1970-01-01T' + this.editedItem.Break.StartTime + ':00Z');
                let breakEnd = new Date('1970-01-01T' + this.editedItem.Break.EndTime + ':00Z');

                // If we are adding a break to a session
                if (this.sessionID && this.sessionID > 0) {
                    let session = this.attendance.Sessions.find(s => s.SessionID == this.sessionID);
                    let sessionStartTime = new Date('1970-01-01T' + session.StartTime + ':00Z');
                    let sessionEndTime = new Date('1970-01-01T' + session.EndTime + ':00Z');

                    let modifiedSession = {
                        SessionID: session.SessionID,
                        AttendanceID: session.AttendanceID,
                        SessionName: session.SessionName,
                        StartTime: session.StartTime,
                        EndTime: session.EndTime
                    };

                    // If we need to split the session
                    if (this.editedItem.SplitSession) {
                        if (breakStart > sessionStartTime && breakEnd < sessionEndTime) {
                            let splitSession = {
                                SessionID: -1,
                                SplitFromID: session.SessionID,
                                AttendanceID: this.attendanceID,
                                SessionName: session.SessionName,
                                StartTime: session.StartTime,
                                EndTime: this.editedItem.Break.StartTime
                            };
                            
                            this.editedItem.Break.SessionID = -1;
                            this.editedItem.ModifiedSessions.push(splitSession);

                            modifiedSession.StartTime = this.editedItem.Break.EndTime;
                        }
                    } else {
                        this.editedItem.Break.SessionID = this.sessionID;

                        if (breakStart > sessionStartTime) {
                            modifiedSession.EndTime = this.editedItem.Break.StartTime;

                            // Need to adjust the ensuing session or break time
                            let following = this.getSessionOrBreakStartingAt(session.EndTime);                            

                            if (following) {
                                following.StartTime = this.editedItem.Break.EndTime;

                                if (following.SessionName) {
                                    this.editedItem.ModifiedSessions.push(following);
                                } else {
                                    this.editedItem.ModifiedBreaks.push(following);
                                }
                            }                            
                        } else {
                            // Extend the session to the end of the break
                            modifiedSession.StartTime = this.editedItem.Break.EndTime;
                        }                        
                    }

                    this.editedItem.ModifiedSessions.push(modifiedSession);
                }

                // If we are modifying a break
                if (this.breakID) {
                    // Lets find the session it is linked to                    
                    let breakModel = null;

                    this.attendance.Sessions.forEach(session => {
                        let match = session.Breaks.find(b => b.BreakID == this.breakID);

                        if (match) {                            
                            breakModel = match;
                            return;
                        }
                    });
                    
                    // Now let's check if we modified the start or end time or both
                    if (breakModel.StartTime != this.editedItem.Break.StartTime) {
                        let preceding = this.getSessionOrBreakEndingAt(breakModel.StartTime);

                        // If we have a preceding period, then adjust the end to match the new start time
                        if (preceding) {
                            preceding.EndTime = this.editedItem.Break.StartTime;

                            if (preceding.SessionName) {
                                this.editedItem.ModifiedSessions.push(preceding);
                            } else {
                                this.editedItem.ModifiedBreaks.push(preceding);
                            }
                        }
                    }

                    if (breakModel.EndTime != this.editedItem.Break.EndTime) {
                        let following = this.getSessionOrBreakStartingAt(breakModel.EndTime);

                        // If we have a ensuing period, then adjust the start to match the new start time
                        if (following) {
                            following.StartTime = this.editedItem.Break.EndTime;

                            if (following.SessionName) {
                                this.editedItem.ModifiedSessions.push(following);
                            } else {
                                this.editedItem.ModifiedBreaks.push(following);
                            }
                        }
                    }
                }
            }
            
            nextTick(() => {
                // Prevent the slider from being dragged
                for (let i = 0; i < this.timeLines.length; i++) {
                    this.$refs['vueSlider' + i][0].unbindEvent();
                    this.$refs['vueSlider' + i][0].onValueChanged();
                }
            });
        },
        timesValid() {
            this.error = null;

            let valid = true;
            let compare = null;

            this.timeLines.forEach(timeLine => {
                let timeA = new Date('1970-01-01T' + timeLine.time[0] + ':00Z');
                let timeB = new Date('1970-01-01T' + timeLine.time[1] + ':00Z');

                if ((compare && compare != timeLine.time[0]) || timeB < timeA) {
                    this.error = "No overlaps or gaps allowed!";
                    valid = false;                   
                }

                if (compare == null || compare == timeLine.time[0]) {
                    compare = timeLine.time[1]
                }
            });

            return valid;
        },
        getSessionOrBreakStartingAt(startTime) {
            let period = null;

            this.attendance.Sessions.forEach(session => {                
                if (session.StartTime == startTime) {
                    period = Object.assign({}, session);
                    return;                  
                }

                session.Breaks.forEach(breakModel => {
                    if (breakModel.StartTime == startTime) {
                        period = Object.assign({}, breakModel);
                        return;
                    }
                });
            });

            return period;
        },
        getSessionOrBreakEndingAt(endTime) {
            let period = null;

            this.attendance.Sessions.forEach(session => {                
                if (session.EndTime == endTime) {
                    period = Object.assign({}, session);
                    return;                  
                }

                session.Breaks.forEach(breakModel => {
                    if (breakModel.EndTime == endTime) {
                        period = Object.assign({}, breakModel);
                        return;
                    }
                });
            });

            return period;
        },
        close() {
            this.$refs.editForm.reset();
            parent.CloseRadWindow();
        },
        async loadData() {
            try {
                this.loading = true;
                this.error = null;

                this.breakTypes = await attendanceApi.getBreakTypes();

                if (this.attendanceID) {

                    if (this.isCropWork) this.attendance = await cropWorkAttendanceApi.getCropWorkAttendanceByID(this.attendanceID);
                    else this.attendance = await attendanceApi.getAttendanceByID(this.attendanceID);
                    
                    this.editedItem.AttendanceID = this.attendanceID;
                }
            }
            catch (err) {
                this.error = err;                
            }
            finally {
                this.loading = false;
            }
        },
        async save() {
            this.saving = true;
            if (!this.timesValid()) {
                this.saving = false;
                return;
            }

            try {        
                this.error = null;
                let result = null;

                if (this.isCropWork) result = await cropWorkAttendanceApi.updateCropWorkAttendance(this.editedItem);
                else result = await attendanceApi.updateAttendance(this.editedItem);                
                
                if (!result.Success) {
                    this.error = result.ErrorMessages.join(', ');
                    return;
                }            

                this.saving = false;
                this.close(true);
            }
            catch (err) {
                this.error = await BaseAPI.parseHttpRequestError(err);
                this.saving = false;
                throw err;
            }
        }
    },
    async mounted() {
        await this.loadData();

        if (this.breakID) {
            this.attendance.Sessions.forEach(session => {
                
                let breakModel = session.Breaks.find(b => b.BreakID == this.breakID);
                
                if (breakModel != null) {
                    this.editedItem.Break.BreakID = breakModel.BreakID;
                    this.editedItem.Break.StartTime = breakModel.StartTime;
                    this.editedItem.Break.EndTime = breakModel.EndTime;
                    this.editedItem.Break.BreakTypeID = breakModel.BreakTypeID;
                }
            });
        }

        nextTick(() => {
            // Prevent the slider from being dragged
            for (let i = 0; i < this.timeLines.length; i++) {
                this.$refs['vueSlider' + i][0].unbindEvent();
            }
        });        
    },
}
</script>
<style scoped>
</style>